import axios from 'axios';
import { useEffect, useState } from 'react';
import { useFormContext } from 'react-hook-form';
import { useNavigate } from 'react-router-dom';

import { Basket } from '../../../Modules/Basket';
import { PaymentMethod, ReceivingMethod } from '../../../api/def_common_api';
import { ApiErrorCode } from '../../../api/errors';
import { setLocalStorage } from '../../../common/util/localStorage';
import { Util } from '../../../common/util/util';
import { useActions } from '../../../hooks/useActions';
import { useBasket } from '../../../hooks/useBasket';
import { useUser } from '../../../hooks/useUser';
import { ICheckout } from '../../../store/basket/basket.interface';
import { useLocalStorageSimple } from '../../../hooks/useLocalStorage';

export const useCheckout = () => {
  const navigate = useNavigate();

  const { setPage } = useActions();

  //Получить токен
  const [sessionToken, setSessionToken] = useLocalStorageSimple('st', '');

  const { loggedIn } = useUser();
  const { items: basketItems, order_sum } = useBasket();
  //Загрузка
  const [loading, setLoading] = useState(false);

  //Подтвердить заказ
  const handleConfirm = async ({
    checkout_email,
    checkout_phone,
    delivery_address,
    delivery_courier_comment,
    delivery_date,
    delivery_sum_kopecks,
    order_sum_kopecks,
    orgName,
    other_recipient_name,
    other_recipient_phone,
    other_recipient,
    payment_method,
    receiving_method,
    is_physical_person,
    userType,
  }: ICheckout) => {
    //Создаем заказ, потом смс-кой подтверждается
    //Создаем заказ
    if (!loggedIn) {
      alert(
        'Вы не авторизованы. Зарегистрируйтесь или авторизуйтесь чтобы оформить заказ'
      );
      return;
    }
    if (is_physical_person) {
      //Физ лицо
      if (checkout_phone === '' || checkout_email === '') {
        alert(
          'Вы не ввели Email или Телефон. Введите Email или Телефон чтобы подтвердить заказ'
        );
        return;
      }
      if (checkout_phone === '' || checkout_phone == null) {
        alert(
          'Вы не авторизованы. Зарегистрируйтесь или авторизуйтесь чтобы оформить заказ'
        );
        return;
      }
      if (!delivery_address && receiving_method === ReceivingMethod.Delivery) {
        alert('Введите адрес доставки');
        return;
      }
      //Если залогирован, то подтверждение по смс для заказа, иначе для авторизации
      if (loggedIn) {
        //Залогирован
        if (checkout_phone !== '') {
          setLoading(true);
          try {
            //Создаем заказ и ждем смс подтверждения заказа
            let order_info = await Basket.createOrder(
              basketItems,
              receiving_method === ReceivingMethod.SelfDelivery
                ? order_sum
                : order_sum + 50000,
              checkout_phone,
              checkout_email,
              receiving_method,
              payment_method,
              is_physical_person,
              receiving_method === ReceivingMethod.SelfDelivery ? 0 : 50000,
              delivery_address,
              delivery_date,
              delivery_courier_comment,
              !other_recipient,
              other_recipient ? '' : other_recipient_name,
              other_recipient ? '' : other_recipient_phone,
              sessionToken
            );

            if (order_info.error_code === ApiErrorCode.no_error) {
              if (PaymentMethod.PaymentOnline === payment_method) {
                if (document.readyState === 'complete') {
                  setLoading(true);
                }
                // @ts-ignore
                window.location = order_info.pay_url;
              }
              if (
                PaymentMethod.PaymentOnDelivery === payment_method ||
                PaymentMethod.BankTransfer === payment_method
              ) {
                navigate('/order-info', {
                  state: { main_order_id: order_info.main_order_id },
                });
              }
            } else {
              alert(order_info.message);
            }
          } catch (e) {
            console.warn(e);
          } finally {
            setLoading(false);
          }
        }
      } else {
        //Не залогирован
        //Логируемся с одноразовым временным паролем по sms, а потом показываем окно с подтверждением по sms для авторизации
        //После этого создаем заказ и переводим юзера на оплату
        //Теперь показываем окно для ввода кода подтверждения
        /*        getPwdWithOneTimePassword(checkoutPhone);*/
      }
    } else {
      //Юр лицо, ИП
      if (checkout_phone === '' || checkout_email === '') {
        alert(
          'Вы не ввели Email или Телефон. Введите Email или Телефон чтобы подтвердить заказ'
        );
        return;
      }
      if (checkout_phone === '' || checkout_phone == null) {
        alert(
          'Вы не авторизованы. Зарегистрируйтесь или авторизуйтесь чтобы оформить заказ'
        );
        return;
      }
      if (!delivery_address && receiving_method === ReceivingMethod.Delivery) {
        alert('Введите адрес доставки');
        return;
      }
      if (loggedIn && checkout_phone !== '' && checkout_email !== '') {
        //Залогирован
        //Создаем заказ
        setLoading(true);
        //У юр.лица телефон и email берем из redux, т.к. он уже залогинен
        try {
          let order_info = await Basket.createOrder(
            basketItems,
            receiving_method === ReceivingMethod.SelfDelivery
              ? order_sum
              : order_sum + 50000,
            checkout_phone,
            checkout_email,
            receiving_method,
            payment_method,
            is_physical_person,
            receiving_method === ReceivingMethod.SelfDelivery ? 0 : 50000,
            delivery_address,
            delivery_date,
            delivery_courier_comment,
            !other_recipient,
            other_recipient ? '' : other_recipient_name,
            other_recipient ? '' : other_recipient_phone,
            sessionToken
          );

          if (
            order_info.error_code ===
            ApiErrorCode.catalog_item_is_not_available_or_no_availability_count
          ) {
            if (order_info) {
              // @ts-ignore
              alert(order_info.message);
            }
            return;
          }
          setLocalStorage.saveToLocalStorage(
            'main_order_id',
            order_info.main_order_id
          );
          if (order_info.error_code === ApiErrorCode.no_error) {
            if (PaymentMethod.PaymentOnline === payment_method) {
              if (document.readyState === 'complete') {
                setLoading(true);
              }
              // @ts-ignore
              window.location = order_info.pay_url;
            }
            if (
              PaymentMethod.PaymentOnDelivery === payment_method ||
              PaymentMethod.BankTransfer === payment_method
            ) {
              navigate('/order-info', {
                state: { main_order_id: order_info.main_order_id },
              });
            }
          } else if (order_info.error_code === ApiErrorCode.inn_not_found) {
            //Временный alert (пока дизайна нет):
            alert('ИНН не установлен. Зарегистрируйтесь как юр.лицо');
            setLoading(false);
            return;
          } else {
            alert(order_info.message);
          }
        } catch (e) {
          console.warn(e);
        } finally {
          setLoading(false);
        }
      }
    }
  };
  useEffect(() => {
    setPage('basket');
  }, []);

  return {
    checkoutData: { loading },
    actions: {
      handleConfirm,
    },
  };
};
